<template>
<div id = "vue-gamelist" class="promotionTemplate" :class="{'_landscape':isLandscape}" v-if="gameList != null">
    <div class="promotionTemplate-mainItem" v-on:click="showLogin" :class="'JARVIS_LandingPage_FreeToPlay_Btn_'+stringTrim(mainGame.gameName)">
      <img :title="mainGame.gameName" :src="mainGame.iconPath">      
    </div> 
    <div class="promotionTemplate-otherItems">
      <div v-for="(game,index) in games" :key="index" class="promotionTemplate-item" v-on:click="showLogin" :class="'JARVIS_LandingPage_FreeToPlay_Btn_'+stringTrim(game.gameName)">
        <img :title="game.gameName" :src="game.iconPath">
      </div>
    </div>  
</div>    
</template>

<script>

export default {
    name: 'PopularGameList',
    props: {
        gameList : null,
        language : '',       
        isLandscape: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        mainGame() {
            if (this.gameList !== null) {
                return this.gameList[0];
            }
            return null;
        },
        games() {
            if (this.gameList !== null) {
                return this.gameList.slice(1, 5);
            }
            return null;
        },
    },
    methods: {
        stringTrim(text) {
            let newText = text.replace(/ /g, "")
            return newText
        },

        showLogin() {
            window.eventEmitter.emit('pp.showLogin', 'Games');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/components/common/promotionTemplate";
</style>

